import React from 'react'

import { Popover, Text } from '@hhgtech/hhg-components/mantine'
import { Calendar } from '@hhgtech/icons/other'
import { Box, Button, Flex, rem } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useIntl } from 'react-intl'

import { Disclaimer } from 'components/atoms/disclaimer'
import ExternalUrl from 'components/atoms/icons/ExternalUrl'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { BlockItemPropsType } from '..'

const FlatIcon = ({
  icon = <Calendar />,
  title,
  bgColor = 'blue.6',
  layout = 'vertical',
  fullWidth,
  className,
  classNames,
  styles,
  iconSize = 32,
  hideTitle,
  isSelected = false,
  useBgColor,
  isExternalUrl,
  ...boxProps
}: BlockItemPropsType) => {
  const { classes, cx } = useStyles(
    {
      bgColor,
      layout,
      fullWidth,
      isSelected,
      useBgColor,
    },
    { name: 'CarePathHeroBannerNavigatorItemFlatIcon', classNames, styles },
  )
  const isMobile = useIsMobile()
  const [opened, { close, open }] = useDisclosure(false)
  const { formatMessage: f } = useIntl()

  const hintText = (
    <Flex gap={rem(4)} align={'center'} sx={{ color: 'transparent' }}>
      <ExternalUrl size={18} color="inherit" />
      <Text size="n1" color="inherit">
        {f({
          id: 'ctaBanner.leavingSite',
          defaultMessage: 'Leaving site',
        })}
      </Text>
    </Flex>
  )

  return (
    <Box
      className={cx(classes.root, className)}
      data-is-selected={isSelected}
      onMouseEnter={open}
      onMouseLeave={close}
      {...boxProps}
    >
      <Box className={cx(classes.imgWrapper, 'img-wrapper')}>
        {React.cloneElement(icon, {
          size: isMobile ? 24 : iconSize,
          color: '#fff',
        })}
      </Box>
      {!hideTitle && title && (
        <Text
          className={classes.title}
          size="s3"
          weight="semiBold"
          data-is-selected={isSelected}
        >
          {title}
        </Text>
      )}
      {isExternalUrl && (
        <ExternalUrl
          size={18}
          className={classes.externalIcon}
          color="#87909C"
        />
      )}
      {isExternalUrl && !isMobile ? (
        <Box className={classes.hint}>
          <Popover
            width={240}
            withinPortal
            position="bottom"
            withArrow
            shadow="md"
            opened={opened}
            classNames={{
              dropdown: classes.popoperDropdown,
              arrow: classes.popoperArrow,
            }}
          >
            <Popover.Target>
              <Button
                sx={{
                  pointerEvents: 'auto',
                  height: 'auto',
                  padding: 0,
                }}
              >
                {hintText}
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <Disclaimer
                classNames={{
                  root: classes.disclaimer,
                  content: classes.disclaimerText,
                }}
                content={f({ id: 'ctaBanner.disclaimer.externalUrl' })}
              />
            </Popover.Dropdown>
          </Popover>
        </Box>
      ) : null}
    </Box>
  )
}

FlatIcon.displayName = 'FlatIcon'

export { FlatIcon }
